var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"background":"#fff","padding-top":"90px"}},[(_vm.campaign.screen === 'one')?_c('edit-campaign-form-one'):(_vm.campaign.screen === 'two')?_c('edit-campaign-form-two'):(_vm.campaign.screen === 'three')?_c('edit-campaign-form-three'):_c('campaign-edit-success')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }